<template>
  <div class="">
    <div class="row col-md-12 d-flex" style="padding: 10rem">
      <v-card class="col-md-12">
        <div class="col-md-12 text-gray mt-5">
          1.TPA speaks with their client about paying their point solution
          vendor invoices through the client’s health plan account. <br />
          2. The TPA adds their client in the platform, and adds at least one of
          the client’s vendors into the platform: <br />
          <div class="col-md-12 ml-3">
            a. This triggers an email through the platform to the client (see
            content below) <br />
            b. This email should have a token with the client’s info: Company
            Name, Tax ID, Contact First Name, Contact Last Name, Contact Email
            as well as the vendor’s name <br />
            a. The email will also contain a link for the client to click to
            confirm their approval<br />
            b. Also at the bottom of the email, typical disclaimer stuff along
            with a link to the Apaly Health Terms of Use agreement. <br />
          </div>

          When the client clicks to Approve the point soluton vendors, then the
          platform updates the vendor/client relationship from pending to
          active. <br />
          This takes place on the Vendor’s Portal as well as the TPA/Broker
          Portal.
        </div>
        <br /><br />
        <br />
        <div class="col-md-12 text-gray">
          <div class="text-underline">EMAIL CONTENT</div>
          <br /><br />
          <div>SUBJECT: Request from ≺ TPA Name ≻</div>
          <br /><br />
          <div>BODY:</div>
          <br />

          <div>Dear First ≺ Name of Client Contact ≻,</div>
          <br />
          <div>
            Can you please click the link below to view and approve the vendors
            / solutions who you would like to be paid as claims through your
            health plan funds account
          </div>
          <br />
          <div>
            <a @click="dialog = true" class="text-underline"
              >View Solution Vendors</a
            >
          </div>
          <br />
          <div>Sincerely,</div>
          <br />
          <div>≺ First Name Last Name of TPA Contact ≻</div>

          <br /><br /><br />

          <div class="col-md-10 pl-0">
            When you click the link above and select and approve the solution
            vendors listed, you are authorizing your plan administrator to
            process and pay claims received by Apaly Health Inc. for the servies
            that were provided by each of the approved solution vendors and
            agree to the Apaly Health Inc.
            <span class="text-underline pointer">Terms of Use Agreement.</span>
          </div>
          <br /><br /><br />
        </div>
      </v-card>
    </div>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <h3 class="text-gray col-md-12 text-center">
          Vendor / Solution Approval
        </h3>
        <div class="col-md-12 text-gray">
          <div class="row col-md-12">
            <div class="col-md-3 text-end">
              <div>Company:</div>
              <div>Tax ID:</div>
              <div>Contact:</div>
              <div>Email:</div>
            </div>
            <div class="col-md-9">
              <div>Prudential</div>
              <div>12-3456789</div>
              <div>Andy Gregg</div>
              <div>andy.gregg@prudential.com</div>
            </div>
          </div>
        </div>
        <h3 class="col-md-12 text-gray text-center">
          Vendor / Solution List for Approval
        </h3>
        <div class="col-md-10 text-gray ml-10">
          The vendors selected below will be paid as claims through health
          plan’s fund account.
        </div>
        <br />
        <div class="row col-md-10 ml-10">
          <div
            @click="selectAll"
            :class="all ? 'fill-blue-checkbox' : 'blue-checkbox'"
          ></div>
          <span class="ml-3 text-gray"> Select All</span>
        </div>
        <v-divider class="col-md-10 ml-8 mt-3 pb-0"></v-divider>

        <v-card-text
          style="height: 200px; overflow-y: scroll"
          class="col-md-10 ml-8 pt-0 mt-0"
        >
          <div
            class="row col-md-12"
            v-for="(item, index) in items"
            :key="index"
          >
            <div
              @click="checkItem(item)"
              :class="item.checked ? 'fill-blue-checkbox' : 'blue-checkbox'"
            ></div>

            <span class="ml-3 text-gray"> {{ item.text }}</span>
          </div>
        </v-card-text>
        <v-divider class="col-md-10 ml-8"></v-divider>
        <br />
        <div class="col-md-11" align="end">
          <v-btn
            style="
              font-size: 18px !important;
              padding: 20px;
              background: #0573f3 !important;
            "
            class="blue-buttons"
            text
            @click="
              dialog = false;
              dialog1 = true;
            "
          >
            Approve Selected Vendors / Solutions
          </v-btn>
        </div>
        <br />
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog1" max-width="550px">
      <v-card>
        <div class="col-md-12" align="center">
          <br /><br />
          <div class="col-md-8 green-success-modal mt-6">
            <svg
              class="mt-2"
              width="54"
              height="54"
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M48.5241 20.7069C48.3196 21.4829 47.9038 22.1817 47.3262 22.7203L45.166 24.7383C44.7439 25.1322 44.4066 25.6134 44.1756 26.1507C43.9447 26.6879 43.8254 27.2693 43.8254 27.8573C43.8254 28.4452 43.9447 29.0266 44.1756 29.5639C44.4066 30.1011 44.7439 30.5823 45.166 30.9762L47.3262 32.9943C47.9495 33.5756 48.3833 34.3423 48.5682 35.189C48.753 36.0357 48.6797 36.9208 48.3584 37.7227C48.0371 38.5246 47.4835 39.2039 46.7738 39.6672C46.064 40.1305 45.233 40.3551 44.3948 40.3102L41.4878 40.1562C40.9203 40.1265 40.353 40.2202 39.8227 40.4314C39.2923 40.6426 38.8108 40.9665 38.409 41.3822C38.0073 41.7978 37.6944 42.2961 37.4904 42.8446C37.2865 43.3932 37.1961 43.9799 37.2252 44.5668L37.3741 47.5732C37.4191 48.4409 37.2029 49.3018 36.7552 50.0371C36.3074 50.7725 35.6503 51.3462 34.8741 51.6792C34.098 52.0122 33.2411 52.0882 32.4215 51.8966C31.6019 51.705 30.86 51.2553 30.2978 50.6094L28.3465 48.3753C27.9656 47.9389 27.5003 47.59 26.9808 47.3511C26.4613 47.1123 25.8991 46.9889 25.3306 46.9889C24.7621 46.9889 24.1999 47.1123 23.6804 47.3511C23.1609 47.59 22.6957 47.9389 22.3148 48.3753L20.3634 50.6094C19.8011 51.2544 19.0593 51.7033 18.2401 51.8943C17.4209 52.0854 16.5646 52.0092 15.789 51.6763C15.0134 51.3434 14.3566 50.7702 13.909 50.0354C13.4614 49.3006 13.2449 48.4404 13.2894 47.5732L13.445 44.5668C13.474 43.9797 13.3836 43.3928 13.1795 42.8441C12.9755 42.2953 12.6623 41.797 12.2603 41.3813C11.8584 40.9656 11.3765 40.6417 10.8459 40.4307C10.3153 40.2196 9.74781 40.1261 9.18008 40.1562L6.27311 40.3102C5.43493 40.3551 4.60385 40.1305 3.8941 39.6672C3.18436 39.2039 2.63079 38.5246 2.30948 37.7227C1.98818 36.9208 1.91491 36.0357 2.09974 35.189C2.28457 34.3423 2.71844 33.5756 3.3417 32.9943L5.50192 30.9762C5.92395 30.5823 6.26134 30.1011 6.49226 29.5639C6.72319 29.0266 6.8425 28.4452 6.8425 27.8573C6.8425 27.2693 6.72319 26.6879 6.49226 26.1507C6.26134 25.6134 5.92395 25.1322 5.50192 24.7383L3.3417 22.7203C2.719 22.1393 2.2854 21.3733 2.10044 20.5273C1.91547 19.6813 1.9882 18.7969 2.30863 17.9953C2.62907 17.1938 3.18151 16.5145 3.89013 16.0506C4.59876 15.5867 5.42884 15.361 6.26645 15.4044L9.17341 15.5584C9.74169 15.5894 10.3099 15.4966 10.8413 15.2861C11.3727 15.0755 11.8554 14.7518 12.2581 14.336C12.6608 13.9201 12.9746 13.4215 13.179 12.8722C13.3835 12.323 13.4741 11.7355 13.445 11.1477L13.2894 8.14137C13.2439 7.27374 13.4596 6.41286 13.9069 5.6773C14.3542 4.94175 15.0109 4.36769 15.7868 4.03419C16.5626 3.7007 17.4193 3.62417 18.239 3.81514C19.0586 4.00612 19.8008 4.4552 20.3634 5.10055L22.3148 7.33462C22.6953 7.77172 23.1604 8.12121 23.68 8.36044C24.1995 8.59968 24.7619 8.7233 25.3306 8.7233C25.8993 8.7233 26.4617 8.59968 26.9813 8.36044C27.5008 8.12121 27.9659 7.77172 28.3465 7.33462L30.2978 5.10055C30.8612 4.45812 31.603 4.01165 32.4215 3.82237C33.24 3.63308 34.095 3.71024 34.8694 4.04327"
                stroke="#09951F"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.2227 23.5822L22.8077 31.2843C23.1087 31.6991 23.4964 32.0384 23.9418 32.2768C24.3873 32.5152 24.879 32.6466 25.3803 32.6612C25.8817 32.6758 26.3798 32.5732 26.8375 32.361C27.2951 32.1489 27.7006 31.8327 28.0238 31.436L51.9995 2"
                stroke="#09951F"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <h3 class="green--text col-md-6 pt-1">
              Your Approval was Received
            </h3>
          </div>
          <br /><br />
          <a class="text-underline font-weight-bold" @click="dialog1 = false">
            Close</a
          >
          <br />
          <br />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      dialog1: false,
      all: false,
      items: [
        {
          text: "Smartlight Analytics",
          value: "smartlight_analytics",
          checked: false,
        },
        {
          text: "Lyra Health",
          value: "lyra_health",
          checked: false,
        },
        {
          text: "Benewize",
          value: "benewize",
          checked: false,
        },
        {
          text: "Goldfinch",
          value: "goldfinch",
          checked: false,
        },
        {
          text: "Teledoc",
          value: "teledoc",
          checked: false,
        },
        {
          text: "Walrus",
          value: "walrus",
          checked: false,
        },
        {
          text: "Home Thrive",
          value: "home_thrive",
          checked: false,
        },
        {
          text: "Uturn Health",
          value: "uturn_helath",
          checked: false,
        },
        {
          text: "HTA - DPC",
          value: "hta_dpc",
          checked: false,
        },
      ],
    };
  },
  methods: {
    checkItem(item) {
      item.checked = !item.checked;
    },
    selectAll() {
      this.all = !this.all;

      this.items.forEach((el) => {
        if (this.all) {
          el.checked = true;
        } else {
          el.checked = false;
        }
      });
    },
  },
};
</script>